import { SxProps, Theme } from '@mui/material'

import { NEUTRAL_GREY_500 } from '@/common/constants'
import { CHART_CARD_TITLE_SX } from '@/common/styles'

/** The policy name above the cards. Larger than a card title, in the same grey and weight. */
export const POLICY_TITLE_SX = {
  ...CHART_CARD_TITLE_SX,
  fontSize: '24px',
  lineHeight: 1.25,
  // A policy name is user data and can be one long word.
  overflowWrap: 'anywhere',
} satisfies SxProps<Theme>

/** The label above each value or input of the policy form. */
export const FIELD_LABEL_SX = {
  color: NEUTRAL_GREY_500,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: 1.4,
} satisfies SxProps<Theme>
